<template>
  <div class="information-bar">
    <div v-if="($store.state.dropbox && $store.state.dropbox.status) || chosenGenreDisplayText"
    style="position: relative; height: 0; width: 100%">
      <div style="position: absolute; bottom: 0; height:36px; width: 100%">
        <b-row no-gutters class="pl-1" style="white-space: nowrap">
          <b-col id="text-style" v-if="chosenGenreDisplayText" md="auto" cols="2" class="text-muted pt-2">
            סגנון טקסט: {{chosenGenreDisplayText}}
          </b-col>
          <b-col cols="6" v-if="$store.state.dropbox && $store.state.dropbox.status"
            class="text-muted pt-1 dropbox-wrap">
            <div class="d-inline-block">
              <status-bar ref="status-bar" />
            </div>
          </b-col>
          <b-col :cols="chosenGenreDisplayText ? '2' : '4'" class="text-muted pt-2">
            <div v-if="fileSettingsDescription">
              {{ fileSettingsDescription }}
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
  import StatusBar from 'shared/dropbox/StatusBar'
  import {AppConfig} from '../appConfig'
  const textTypes = [
    {
      name: 'modern',
      displayText: 'מודרני',
      engDisplayText: 'Modern'
    },
    {
      name: 'rabbinic',
      displayText: 'רבני',
      engDisplayText: 'Rabbinic'
    },
    {
      name: 'poetry',
      displayText: 'שירה',
      engDisplayText: 'Poetic'
    }
  ]
  if (AppConfig.TALMUD_GENRE.INCLUDE) textTypes.push({
    name: 'talmud',
    displayText: 'טקסט תלמודי',
    engDisplayText: 'Text from the Talmud'
  })
  export default {
    name: 'InformationBar',
    data() {
      return {       
      }
    },
    components: {
      StatusBar
    },
    methods: {
    },
    computed: {
      chosenGenreDisplayText () {
        const options = AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW
        if (!(options.ALL) && !(options.ONLY_GENRE)) return '' // the app doesn't use "genre" at all!
        let chosenTextTypeName = this.$store.state.preSubmissionOptions.chosenTextTypeName
        const abbrevProjectSettings = this.$store.state.dropbox?.projectSettings?.abbreviation
        if (abbrevProjectSettings) {
          chosenTextTypeName = abbrevProjectSettings.genreMode ? abbrevProjectSettings.genreMode : ''
        }
        const chosenTextTypeIndex = textTypes.map(t => t.name).indexOf(chosenTextTypeName)
        return (chosenTextTypeIndex === -1) ? ''
                : (this.$settings.hebrew ? textTypes[chosenTextTypeIndex].displayText
                    : textTypes[chosenTextTypeIndex].engDisplayText)
      },                    
      fileSettingsDescription () {
        const abbrevProjectSettings = this.$store.state.dropbox?.projectSettings?.abbreviation
        return (abbrevProjectSettings && typeof abbrevProjectSettings === 'object')
                ? abbrevProjectSettings.description : null
      }
    }
  }
</script>
<style lang="scss">
  .information-bar {
    .d-inline-block {
      vertical-align: middle;
    }
    .text-muted { text-align: center; }
    .text-muted:first-child { text-align: right; }
    .text-muted:last-child { text-align: left; }
    .custom-control {padding-right: 2.25rem!important;}
  }
</style>
